
import { YoungQuestion } from '@/types/personality';

// Questions for Overvigilance and Inhibition Domain
export const overvigilanceQuestions: YoungQuestion[] = [
  // Esquema: Negatividade/Pessimismo
  {
    id: 43,
    text: "Tenho a sensação de que algo ruim está prestes a acontecer.",
    domain: "overvigilance",
    schema: "negativity"
  },
  {
    id: 44,
    text: "Sinto que desastres (naturais, criminais, financeiros ou médicos) podem ocorrer a qualquer momento.",
    domain: "overvigilance",
    schema: "negativity"
  },
  {
    id: 45,
    text: "Me preocupo com possíveis consequências negativas mesmo quando as coisas estão indo bem em minha vida.",
    domain: "overvigilance",
    schema: "negativity"
  },
  
  // Esquema: Inibição Emocional
  {
    id: 46,
    text: "Tenho dificuldade em expressar meus sentimentos aos outros.",
    domain: "overvigilance",
    schema: "emotional_inhibition"
  },
  {
    id: 47,
    text: "Devo ser racional e não governado por minhas emoções.",
    domain: "overvigilance",
    schema: "emotional_inhibition"
  },
  {
    id: 48,
    text: "As pessoas me veem como alguém emocionalmente contido ou inibido.",
    domain: "overvigilance",
    schema: "emotional_inhibition"
  },
  
  // Esquema: Padrões Inflexíveis
  {
    id: 49,
    text: "Tenho que ser o melhor em tudo o que faço; não posso aceitar ser o segundo melhor.",
    domain: "overvigilance",
    schema: "unrelenting_standards"
  },
  {
    id: 50,
    text: "Tento fazer o meu melhor; não consigo aceitar 'bom o suficiente'.",
    domain: "overvigilance",
    schema: "unrelenting_standards"
  },
  {
    id: 51,
    text: "Preciso cumprir todas as minhas responsabilidades.",
    domain: "overvigilance",
    schema: "unrelenting_standards"
  },
  
  // Esquema: Punitividade
  {
    id: 52,
    text: "As pessoas deveriam receber punição severa por seus erros ou transgressões.",
    domain: "overvigilance",
    schema: "punitiveness"
  },
  {
    id: 53,
    text: "Sou muito crítico comigo mesmo e com os outros.",
    domain: "overvigilance",
    schema: "punitiveness"
  },
  {
    id: 54,
    text: "Tenho grande dificuldade em perdoar os erros dos outros ou os meus próprios.",
    domain: "overvigilance",
    schema: "punitiveness"
  }
];
